import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

export type IIconExpandHorizontalProps = Pick<IProps, 'color' | 'size'>;

const IconExpandHorizontal = ({
  color = colors.black,
  size = 24,
}: IIconExpandHorizontalProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 14.5L12 17.5L9 14.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9.5L12 6.5L15 9.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconExpandHorizontal;
